import { DeveloperHome } from "@/features/developer/developer-home";

export default function DeveloperPage() {
  return <DeveloperHome />;
}
